import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import logo from "../Assets/logo.png";
import profileIcon from "../Assets/profileicon.png";
import { FaUser, FaEnvelope, FaShoppingCart, FaClipboardList, FaSignOutAlt, FaPlus } from "react-icons/fa";
import LoginModal from "./LoginModal";
import SignUpModal from "./SignUpModal";

const Navbar = ({ activeSection }) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userFullName, setUserFullName] = useState("");
  const [logoutMessage, setLogoutMessage] = useState(null);
  const [isNavMenuOpen, setIsNavMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    const userData = localStorage.getItem("userData");

    if (token && userData) {
      const user = JSON.parse(userData);
      setIsLoggedIn(true);
      setUserFullName(user.fullname);
    }
  }, []);

  const user = JSON.parse(localStorage.getItem("userData"));
  const userRole = user?.role;

  const handleLoginSuccess = () => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      const user = JSON.parse(userData);
      setUserFullName(user.fullname);
      setIsLoggedIn(true);
    }
    setIsLoginModalOpen(false);
  };

  const handleLogout = () => {
    setLogoutMessage("Are you sure you want to logout?");
  };

  const confirmLogout = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("userData");
    setIsLoggedIn(false);
    setUserFullName("");
    setIsSidebarOpen(false);
    setLogoutMessage("Logged out successfully!");
    setTimeout(() => setLogoutMessage(null), 2000);
  };

  const closeLogoutPopup = () => {
    setLogoutMessage(null);
    navigate("/");
  };

  const handleAboutClick = () => {
    navigate("/", { state: { scrollTo: "about" } });
  };

  const handleFaqsClick = () => {
    navigate("/", { state: { scrollTo: "faqs" } });
  };

  return (
    <>
      <NavbarContainer>
        <LogoContainer>
          <img src={logo} alt="INA-ANI Logo" />
          <div>
            <LogoText>INA-ANI</LogoText>
            <Tagline>Nurturing Harvests, Empowering Women</Tagline>
          </div>
        </LogoContainer>

        <HamburgerIcon onClick={() => setIsNavMenuOpen(!isNavMenuOpen)}>☰</HamburgerIcon>

        <NavLinks $isOpen={isNavMenuOpen}>
          <span
            className={`nav-button ${activeSection === "home" ? "active" : ""}`}
            onClick={() => {
              navigate("/", { state: { scrollTo: "home" } });
              setIsNavMenuOpen(false);
            }}
          >
            Home
          </span>
          <Link
            to="/marketplace"
            className={`nav-button ${activeSection === "marketplace" ? "active" : ""}`}
            onClick={() => setIsNavMenuOpen(false)}
          >
            Marketplace
          </Link>
          <span
            className={`nav-button ${activeSection === "about" ? "active" : ""}`}
            onClick={() => {
              handleAboutClick();
              setIsNavMenuOpen(false);
            }}
          >
            About
          </span>
          <span
            className={`nav-button ${activeSection === "faqs" ? "active" : ""}`}
            onClick={() => {
              handleFaqsClick();
              setIsNavMenuOpen(false);
            }}
          >
            FAQ's
          </span>
          <ButtonContainerMobile>
            {!isLoggedIn ? (
              <LoginButton
                onClick={() => {
                  setIsLoginModalOpen(true);
                  setIsNavMenuOpen(false);
                }}
              >
                Log In
              </LoginButton>
            ) : (
              <ProfileIcon
                onClick={() => {
                  setIsSidebarOpen(true);
                  setIsNavMenuOpen(false);
                }}
              >
                <img src={profileIcon} alt="Profile" />
              </ProfileIcon>
            )}
          </ButtonContainerMobile>
        </NavLinks>

        <ButtonContainerDesktop>
          {!isLoggedIn ? (
            <LoginButton onClick={() => setIsLoginModalOpen(true)}>Log In</LoginButton>
          ) : (
            <ProfileIcon onClick={() => setIsSidebarOpen(true)}>
              <img src={profileIcon} alt="Profile" />
            </ProfileIcon>
          )}
        </ButtonContainerDesktop>
      </NavbarContainer>

      {isSidebarOpen && (
        <>
          <Overlay onClick={() => setIsSidebarOpen(false)} />
          <Sidebar isOpen={isSidebarOpen}>
            <CloseButton onClick={() => setIsSidebarOpen(false)}>×</CloseButton>
            <SidebarContent>
              <UserSection>
                <ProfileImage src={profileIcon} alt="Profile" />
                <UserName>{userFullName}</UserName>
              </UserSection>
              <MenuItem to="/profile" onClick={() => setIsSidebarOpen(false)}>
                <FaUser /> Profile
              </MenuItem>
              <MenuItem to="/order" onClick={() => setIsSidebarOpen(false)}>
                <FaClipboardList /> Orders
              </MenuItem>
              <MenuItem to="/cart" onClick={() => setIsSidebarOpen(false)}>
                <FaShoppingCart /> Cart
              </MenuItem>
              <MenuItem to="/inbox" onClick={() => setIsSidebarOpen(false)}>
                <FaEnvelope /> Inbox
              </MenuItem>
              {userRole === "seller" && (
                <MenuItem to="/add-product" onClick={() => setIsSidebarOpen(false)}>
                  <FaPlus /> Add Product
                </MenuItem>
              )}

              <LogoutContainer>
                <LogoutButton onClick={handleLogout}>
                  <FaSignOutAlt /> Logout
                </LogoutButton>
              </LogoutContainer>
            </SidebarContent>
          </Sidebar>
        </>
      )}

      <LoginModal
        isOpen={isLoginModalOpen}
        toggleModal={() => setIsLoginModalOpen(false)}
        onLoginSuccess={handleLoginSuccess}
        onSwitchToSignUp={() => {
          setIsLoginModalOpen(false);
          setTimeout(() => setIsSignUpModalOpen(true), 300);
        }}
      />

      <SignUpModal
        isOpen={isSignUpModalOpen}
        toggleModal={() => setIsSignUpModalOpen(false)}
        onSwitchToLogin={() => {
          setIsSignUpModalOpen(false);
          setTimeout(() => setIsLoginModalOpen(true), 300);
        }}
      />

      {logoutMessage && (
        <LogoutPopupOverlay>
          <LogoutPopup>
            <p>{logoutMessage}</p>
            {logoutMessage === "Are you sure you want to logout?" ? (
              <div>
                <button onClick={confirmLogout}>Yes</button>
                <button onClick={closeLogoutPopup}>Cancel</button>
              </div>
            ) : (
              <button onClick={closeLogoutPopup}>OK</button>
            )}
          </LogoutPopup>
        </LogoutPopupOverlay>
      )}
    </>
  );
};

// Styled Components
const NavbarContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e5e5;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
    gap: 0.5rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem 0.75rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    width: 50px;
    height: 50px;
  }

  @media (max-width: 480px) {
    gap: 8px;

    img {
      width: 40px;
      height: 40px;
    }
  }
`;

const LogoText = styled.h1`
  color: #004d00;
  font-size: 1.3rem;
  font-weight: bold;
  margin: 0;

  @media (max-width: 480px) {
    font-size: 1.1rem;
  }
`;

const Tagline = styled.p`
  font-size: 0.85rem;
  color: #004d00;
  margin: 0;

  @media (max-width: 480px) {
    font-size: 0.75rem;
  }
`;

const HamburgerIcon = styled.div`
  display: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #004d00;

  @media (max-width: 768px) {
    display: block;
  }

  @media (max-width: 480px) {
    font-size: 1.3rem;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1rem;

  .nav-button {
    text-decoration: none;
    color: #004d00;
    font-weight: bold;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;

    &.active {
      background-color: #003300;
      color: #ffffff;
    }

    &:hover {
      background-color: #004d00;
      color: #ffffff;
    }
  }

  @media (max-width: 768px) {
    display: ${(props) => (props.$isOpen ? "flex" : "none")};
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #ffffff;
    padding: 1rem;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    z-index: 9;
    gap: 0.5rem;

    .nav-button {
      padding: 0.5rem;
      font-size: 0.9rem;
      text-align: center;
    }
  }

  @media (max-width: 480px) {
    padding: 0.75rem;

    .nav-button {
      font-size: 0.85rem;
      padding: 0.4rem;
    }
  }
`;

const ButtonContainerDesktop = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none; /* Hide on mobile */
  }
`;

const ButtonContainerMobile = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
  }
`;

const LoginButton = styled.button`
  background: #004d00;
  color: #ffffff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 25px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #003300;
  }

  @media (max-width: 480px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
  }
`;

const ProfileIcon = styled.div`
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  @media (max-width: 480px) {
    img {
      width: 35px;
      height: 35px;
    }
  }
`;

const Sidebar = styled.div`
  position: fixed;
  top: 0;
  right: ${(props) => (props.isOpen ? "0" : "-100%")};
  width: 250px;
  height: 100vh;
  background: #ffffff;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  z-index: 100;

  @media (max-width: 480px) {
    width: 200px;
    padding-top: 0.75rem;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;

  @media (max-width: 480px) {
    font-size: 20px;
    top: 8px;
    right: 8px;
  }
`;

const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 15px;
  flex-grow: 1;
  justify-content: center;

  @media (max-width: 480px) {
    gap: 10px;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 99;
`;

const UserSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    margin-bottom: 15px;
  }
`;

const ProfileImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;

  @media (max-width: 480px) {
    width: 50px;
    height: 50px;
  }
`;

const UserName = styled.p`
  font-weight: bold;
  color: #004d00;
  margin-top: 10px;

  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-top: 8px;
  }
`;

const MenuItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: ${(props) => (props.active ? "#ffffff" : "#004d00")};
  background: ${(props) => (props.active ? "#004d00" : "transparent")};
  font-size: 1rem;
  padding: 10px 20px;
  width: 84%;
  border-radius: 20px;
  transition: background 0.3s, color 0.3s;

  &:hover {
    background: #004d00;
    color: #ffffff;
  }

  svg {
    font-size: 18px;
    margin-left: 10px;
    transition: color 0.3s;
  }

  &:hover svg {
    color: #ffffff;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    padding: 8px 15px;
    gap: 10px;

    svg {
      font-size: 16px;
      margin-left: 8px;
    }
  }
`;

const LogoutContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  padding: 20px;
  width: 92%;
  text-align: center;

  @media (max-width: 480px) {
    padding: 15px;
  }
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  border: none;
  background: transparent;
  color: #004d00;
  font-size: 1rem;
  cursor: pointer;
  padding: 10px 20px;
  width: 100%;
  text-align: left;
  border-radius: 20px;
  transition: background 0.3s, color 0.3s;

  &:hover {
    background: #004d00;
    color: #ffffff;
  }

  svg {
    font-size: 18px;
    margin-left: 5px;
    transition: color 0.3s;
  }

  &:hover svg {
    color: #ffffff;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
    padding: 8px 15px;
    gap: 10px;

    svg {
      font-size: 16px;
      margin-left: 5px;
    }
  }
`;

const LogoutPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const LogoutPopup = styled.div`
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 400px;

  p {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  button {
    margin: 5px;
    padding: 8px 16px;
    border: none;
    background: #004d00;
    color: white;
    cursor: pointer;
    border-radius: 5px;
    transition: background 0.3s;
    font-size: 0.9rem;

    &:hover {
      background: #003300;
    }
  }

  @media (max-width: 480px) {
    padding: 15px;
    max-width: 300px;

    p {
      font-size: 0.9rem;
      margin-bottom: 0.75rem;
    }

    button {
      padding: 6px 12px;
      font-size: 0.85rem;
    }
  }
`;

export default Navbar;